var render, staticRenderFns
import script from "./BodyLink.vue?vue&type=script&lang=ts"
export * from "./BodyLink.vue?vue&type=script&lang=ts"
import style0 from "./BodyLink.vue?vue&type=style&index=0&id=2aac376d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aac376d",
  null
  
)

export default component.exports